/**
 * Throttle por elemento: evita duplicar eventos del mismo target dentro de una
 * ventana de N ms. Usa un WeakMap para no retener elementos en memoria.
 */
export class ElementThrottle {
  private lastFired = new WeakMap<Element, number>();

  constructor(private readonly windowMs: number) {}

  /** Devuelve true si el elemento puede emitir ahora (y registra el disparo). */
  shouldFire(element: Element): boolean {
    const now = Date.now();
    const last = this.lastFired.get(element) ?? 0;

    if (now - last < this.windowMs) return false;

    this.lastFired.set(element, now);
    return true;
  }
}
